/**
 * A session's times, as the game server keeps them.
 *
 * The admin's sessions screen draws a session's timeline by these and turns a
 * script's quarters into its length; a student's session card says when the
 * lobby opens. Each is the game server's, held to it by a Go test that reads
 * this file — docs/SERVER-CLIENT-SYNC.md names the pairs. The lobby's
 * five minutes were written twice in the portal, and they, the quarter's ticks
 * and the tick's minutes were held by nothing.
 */

/**
 * The lobby opens this many minutes before a session's start, when the
 * scheduler makes its match (session-scheduler.go, AdvanceNoticeMinutes).
 */
export const LOBBY_PRE_MINUTES = 5;

/**
 * The room closes this many minutes after a session's end: the end lobby's
 * length (match_phase.go, EndLobbyDurationSecs).
 */
export const LOBBY_POST_MINUTES = 5;

/**
 * How long a session with no length of its own runs, after which the game
 * server ends its match and refuses a join as ended (session-scheduler.go,
 * ScriptSessionFallbackMinutes). Its script may end it sooner.
 */
export const SESSION_SCRIPT_FALLBACK_DURATION_MINUTES = 90;

/** A quarter's ticks (finance/ledger.go, TicksPerQuarter). */
export const TICKS_PER_QUARTER = 3;

/** The real minutes from one tick to the next (match-handler.go, RuntimeConfig.SimIntervalMinutes). */
export const SIM_INTERVAL_MINUTES = 1;
